// Loader.jsx
import React from "react";
import "./Loader.css"; // Import the CSS for the loader

const Loader = () => {
  return (
    <div className={`pt-[60px] min-h-[calc(100vh-80px)] bg-gradient-to-br from-[#010920] to-[#163c69] flex justify-center items-center`}>
  <span className="loader"></span>

    </div>
)
};

export default Loader;